var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"welcome"}},[_c('iframe',{style:({'min-height' : _vm.height + 'px'}),attrs:{"src":_vm.srcUri,"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }